import styled, { css } from 'styled-components';
import { ApMenu, colors } from '@alixpartners/ui-components';

export const StyledMenu = styled(ApMenu)`
	padding-bottom: 0 !important;
	overflow: hidden !important;
	display: flex;
	flex-direction: column;
	max-width: 272px !important;
	min-width: 200px !important;
	max-height: calc(100% - 102px) !important;

	${({ isVirtualList }) =>
		isVirtualList &&
		css`
			height: 100%;
		`};
`;

export const CounterWrapper = styled.div`
	position: absolute;
	right: 8px;
	top: -8px;
	border-radius: 16px;
	background-color: ${colors.green2};
	height: 16px;
	min-width: 16px;
	color: white;
	font-size: 11px;
	font-weight: 500;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 4px;
	z-index: 2;
`;

export const Backdrop = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 999;
`;

export const ModalContainer = styled.div`
	background: white;
	width: 1200px;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
	z-index: 1000;
`;

export const ModalHeader = styled.div`
	border-bottom: 1px solid #ccc;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 5px 15px;
	> div {
		color: ${colors.grey5};
		font-weight: 600;
	}
`;

export const ModalNameContainer = styled.div`
	background: white;
	width: 500px;
	height: auto;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
	z-index: 1000;
`;

export const ModalInfoContainer = styled.div`
	background: white;
	width: 1000px;
	height: 400px;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
	z-index: 1000;
`;
